import { Auth0Context, Auth0ContextInterface, useAuth0 } from '@auth0/auth0-react'
import React, { useMemo } from 'react'

export const Auth0ContextOverrideProvider: React.FC = ({ children }) => {
  const { loginWithRedirect, ...auth0ContextRest } = useAuth0()

  const contextValue = useMemo(
    (): Auth0ContextInterface => ({
      ...auth0ContextRest,
      loginWithRedirect: (options) =>
        loginWithRedirect({
          'ext-home-url': typeof window !== 'undefined' ? window.location.origin : '',
          ...options,
        }),
    }),
    [auth0ContextRest, loginWithRedirect],
  )

  return <Auth0Context.Provider value={contextValue}>{children}</Auth0Context.Provider>
}
